import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="claim-toggle"
export default class extends Controller {
  static targets = ["section", "button"]
  
  toggle() {
    this.sectionTarget.classList.toggle('hidden')
    
    if (this.sectionTarget.classList.contains('hidden')) {
      this.buttonTarget.innerHTML = `
        <svg class="h-5 w-5 inline-block mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
        Add Certificate
      `
    } else {
      this.buttonTarget.innerHTML = 'Hide Form'
    }
  }
}
